import styled from 'styled-components';

const Row = styled.div.attrs(() => ({
  className: 'row',
}))`
  margin-top: ${({ marginTop }) => ((marginTop) ? `${marginTop}px` : 0)};
  margin-bottom: ${({ marginBottom }) => ((marginBottom) ? `${marginBottom}px` : 0)};
`;

export default Row;
